import React from 'react';
import { volumes } from '../data/teknik';

// Neutral CSS placeholders, only shown if an image slot in data/teknik.ts is empty.
export function ProductBoxPlaceholder({
  className = ''
}: {
  className?: string;
}) {
  return <div role="img" aria-label="KRLE KLAR™ – 6 digitale bind i KRLE for 1.–10. trinn" className={`relative mx-auto w-full max-w-sm ${className}`} data-id="element-265" data-mp="1eth7ru44zxx7">
      <div className="rounded-2xl bg-slate-900 p-5 text-white shadow-2xl shadow-slate-900/30" data-id="element-266" data-mp="19tl9mbi4f0pk">
        <p className="text-xs font-semibold uppercase tracking-widest text-white/70" data-id="element-267" data-mp="15rho0u1qmfqk">1.–10. trinn · LK20</p>
        <p className="mt-1 font-serif text-4xl leading-none tracking-tight" data-id="element-268" data-mp="vvodthbhqyby">KRLE KLAR<span className="align-super text-[0.45em]" data-id="element-269" data-mp="vxr13tl9edcz">™</span></p>
        <p className="mt-2 text-sm leading-snug text-white/80" data-id="element-270" data-mp="qxmtyu68quzf">Religion · Livssyn · Etikk</p>
        <div className="mt-5 grid grid-cols-6 gap-1.5" data-id="element-271" data-mp="2q9xm1k3yg8ih">
          {volumes.map(v => <div key={v.number} className={`flex h-36 flex-col justify-between rounded-md border-r-4 border-black/10 p-1.5 ${v.spine}`} data-id="element-272" data-mp="2laujc6bg6edo">
              <span className="text-[9px] font-bold opacity-80" data-id="element-273" data-mp="2t5l8ie6soziv">{v.number.replace('Bind ', 'V')}</span>
            </div>)}
        </div>
        <p className="mt-4 text-center text-sm font-semibold text-red-300" data-id="element-274" data-mp="2y3eep783ltj5">6 bind + 5 bonuser</p>
      </div>
    </div>;
}
export function PagePlaceholder({
  label,
  title
}: {
  label: string;
  title: string;
}) {
  return <div className="flex h-full w-full flex-col bg-white" aria-hidden="true" data-id="element-275" data-mp="3bwvvik9egs5h">
      <div className="flex items-center justify-between bg-slate-900 px-4 py-3 text-white" data-id="element-276" data-mp="3byyvnx49o1nx">
        <span className="text-[11px] font-bold uppercase tracking-widest" data-id="element-277" data-mp="3gv73sqk1qull">KRLE KLAR™</span>
      </div>
      <div className="flex flex-1 flex-col gap-3 p-5" data-id="element-278" data-mp="326svi03v2dxn">
        <p className="text-[11px] font-bold uppercase tracking-widest text-red-700" data-id="element-279" data-mp="375dslqntghhv">{label}</p>
        <p className="font-serif text-xl leading-tight text-slate-900" data-id="element-280" data-mp="3uvhwlz4x2j9e">{title}</p>
      </div>
    </div>;
}